import React from "react";
import { RITUAL_BRAND } from "@/data/ritualBrand";

export const RitualWordmark = ({ tone = "white", variant = "wordmark", className = "", testId, onLoad }) => {
  const full = variant === "lockup";
  const family = full ? RITUAL_BRAND.lockups : RITUAL_BRAND.wordmarks;
  return <img
    src={family[tone]} width={family.width} height={family.height}
    alt={full ? "RITUAL CAFÉ" : "RITUAL"}
    className={`rh-official-wordmark ${full ? "rh-official-lockup" : ""} ${className}`}
    data-testid={testId} data-brand-variant={variant} data-brand-tone={tone}
    loading={full ? "lazy" : "eager"} decoding="async" draggable={false} onLoad={onLoad}
  />;
};